import { render, staticRenderFns } from "./getmeterenergydatabyyear.vue?vue&type=template&id=316b8b38&scoped=true&"
import script from "./getmeterenergydatabyyear.vue?vue&type=script&lang=js&"
export * from "./getmeterenergydatabyyear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316b8b38",
  null
  
)

export default component.exports